export default __webpack_public_path__ + "static/media/info-icon-blue.7cfbd0be.svg";